module.exports = __webpack_public_path__ + "img/DSC_1829.8eb52078.jpeg";